import camelCase from 'lodash/camelCase.js';
import isArray from 'lodash/isArray.js';
import isObject from 'lodash/isObject.js';

const toCamelCase = (obj) => {
  if (!isObject(obj)) {
    return obj;
    // eslint-disable-next-line no-else-return
  } else if (isArray(obj)) {
    return obj.map((string) => toCamelCase(string));
  }

  const ret = {};
  Object.entries(obj).forEach(([k, v]) => {
    ret[camelCase(k)] = toCamelCase(v);
  });

  return ret;
};

export default toCamelCase;
